import canBrowserPlayAudio, { isAudioContextSuspended } from '../../sounds/canBrowserPlayAudio';
import { isLoadedInSoundSource, playSoundFromSoundSource } from '../../sounds/playSoundFromSoundSource';
import playSoundWithHowler from '../../sounds/playSoundWithHowler';
import playSoundWithWebAudio from '../../sounds/playSoundWithWebAudio';
import isWebOsAppSuspended from '../../sounds/detectWebOsSuspendedApp';
import { setSentryAudioMode } from '../../utils/setupSentry';
import AudioStatusIndicator from '../../sounds/AudioStatusIndicator';

let useHowler = true;

export default function soundExecutor({ sound: soundUrl = '/static/sounds/cash.mp3', playCount = 1 }, done) {
	log(`Notifications.doSound "${soundUrl}" ${playCount} times`);
	
	if (canBrowserPlayAudio()) {
		// Check if AudioContext is suspended and show indicator if feature is enabled
		if (isAudioContextSuspended() && Screen.options.audioStatusIndicatorEnabled) {
			log('AudioContext is suspended, showing audio status indicator');
			// Force check state to show the toast
			AudioStatusIndicator.checkState();
		}

		if (isLoadedInSoundSource(soundUrl)) {
			setSentryAudioMode('sound source');
			if (!isWebOsAppSuspended()) {
				return playSoundFromSoundSource(soundUrl, playCount, done);
			} else {
				log('WebOS app is suspended, skipping sound source playback');
			}
		} else {
			const soundPlayTimeout = setUpAudioFailInterval();
			
			const onDone = () => {
				done?.();
			};

			setSentryAudioMode(useHowler ? 'howler' : 'web audio');

			return useHowler ? 
				playSoundWithHowler(soundUrl, playCount, soundPlayTimeout, onDone)
				: playSoundWithWebAudio(soundUrl, playCount, soundPlayTimeout, onDone);
		}
			
	} else {
		log('No audio context available, skipping sound');
		done();
	}
}

const soundNotPlayingTimeout = 2000;

function setUpAudioFailInterval() {
	const soundNotPLaying = () => {
		log('Audio from executor did not play');
		if (useHowler) {
			useHowler = false;
			setSentryAudioMode('web audio');
			log('Change audio mode to web audio');
		}
	};

	return setTimeout(soundNotPLaying, soundNotPlayingTimeout);
}

export function playSound(url) {
	let testTimeout;
	let onEnded;
	if (canBrowserPlayAudio()) {
		// Check if AudioContext is suspended and show indicator if feature is enabled
		if (isAudioContextSuspended() && Screen.options.audioStatusIndicatorEnabled) {
			log('AudioContext is suspended, showing audio status indicator');
			// Force check state to show the toast
			AudioStatusIndicator.checkState();
		}
		
		if (isWebOsAppSuspended()) {
			clearTimeout(testTimeout);
		} else {
			playSoundFromSoundSource(url, 1, null, onEnded);
		}

	} else {
		return false;
	}
}
